import React, { FC, useCallback, useEffect, useState } from "react";

import { v4 } from "uuid";

import { useCarousel } from "hooks/useCarousel";

import { Card } from "components";

import { useVoeBizApi } from "services/services";
import { TCategories } from "services/types";

const CategoryBenefits: FC = () => {
  const api = useVoeBizApi();

  const [tier, setTier] = useState<string>();
  const [isClubSmls, setIsClubSmls] = useState(false); // estado pra dizer se o cliente faz parte do clube
  const [chooseClubSmls, setChooseSmlsClube] = useState(false); // qual botão ele apertou
  const [categories, setCategories] = useState<TCategories>();
  const [sectionTitle, setSectionTitle] = useState<string>();

  const cardsIndex = (isClubSmls && chooseClubSmls ? "club" : tier?.toLowerCase()?.replace(" ", "-")) as
    | keyof TCategories
    | undefined;

  const cards = categories && cardsIndex ? categories[cardsIndex] : [];

  const { containerRef, carouselState } = useCarousel({ cards, className: "category-benefits-card" });

  const fetchCategoryBenefitsData = useCallback(() => {
    api.getCategoryBenefitsData().then((res) => {
      if (res) {
        setSectionTitle(res.title);
        setCategories(res.cards);
      }
    });
  }, [api]);

  const getTier = useCallback(async () => {
    const result = await api.getTier();
    setTier(result);
  }, [api]);

  const getIsClub = useCallback(() => {
    api.getIsClub().then((result) => {
      setIsClubSmls(result);
    });
  }, [api]);

  const handleSelectSmlsClube = () => setChooseSmlsClube(true);
  const handleSelectCategories = () => setChooseSmlsClube(false);

  useEffect(() => {
    getTier();
  }, [getTier]);

  useEffect(() => {
    fetchCategoryBenefitsData();
  }, [fetchCategoryBenefitsData]);

  useEffect(() => {
    getIsClub();
  }, [getIsClub]);

  if (!categories || !tier) return null;

  return (
    <section className="liferay-category-benefits" data-testid="category-benefits" id="category-benefits">
      {sectionTitle && (
        <>
          <div className="mainHeader">
            <h2 className="title title-primary">{sectionTitle}</h2>
            <h2 className="title title-secondary">
              Confira os benefícios da <strong>Categoria Exclusive</strong>
            </h2>
          </div>
          {isClubSmls && cardsIndex !== "exclusive" && (
            <div className="tab-buttons">
              <button
                className={`tab-buttons__button${!chooseClubSmls ? " current" : ""}`}
                type="button"
                onClick={handleSelectCategories}
              >
                Categoria {tier}
              </button>
              <button
                className={`tab-buttons__button${chooseClubSmls ? " current" : ""}`}
                type="button"
                onClick={handleSelectSmlsClube}
              >
                Clube Smiles para Empresas
              </button>
            </div>
          )}

          <div className={`cards-${chooseClubSmls ? "club" : "categories"} cards`} ref={containerRef}>
            {cards.map(({ title, description, icon, color }) => (
              <Card key={v4()} title={title} description={description} icon={icon} color={color} />
            ))}
          </div>

          <div className="mobile-dots">
            {cards.map((_card, index) => (
              <span className={`mobile-dots__dot${index + 1 === carouselState.current ? " current" : ""}`} key={v4()} />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default CategoryBenefits;
